import { http } from "@/http";
import { imgServe } from "@/imageServe";

const PATH = "app/reports/visit-clients";

class ReportVisitClientsService {
  async getAll(params = {}) {
    return http.get(PATH, { params });
  }

  async getById(id) {
    return http.get(PATH.concat('/').concat(id));
  }

  async create(payload) {
    return http.post(PATH, payload);
  }

  async update(id, payload) {
    return http.post(PATH.concat('/').concat(id).concat("/edit"), payload);
  }

  async disable(id) {
    return http.patch(PATH.concat('/').concat(id).concat("/disable"));
  }

  async enable(id) {
    return http.patch(PATH.concat('/').concat(id).concat("/enable"));
  }

  async saveLogo(file) {
    const headers = {
      headers: {
        BASE_PATH: process.env.VUE_APP_BASE_API_URL,
        __company: localStorage.getItem("__company"),
      },
    };

    return imgServe.post("new-file", { file }, headers);
  }

  async replaceLogo(file, currentPath) {
    const headers = {
      headers: {
        BASE_PATH: process.env.VUE_APP_BASE_API_URL,
        __company: localStorage.getItem("__company"),
        __company_path: currentPath,
      },
    };

    return imgServe.post("replace-file", { file }, headers);
  }
}

export default new ReportVisitClientsService();
export { PATH };